import { gql } from "graphql-request";

export const CREATE_BUSINESS_STRUCTURE = gql`
  mutation CreateBusinessStructure($input: CreateBusinessStructureInput!) {
    createBusinessStructure(input: $input) {
      id
      tenantId
      name
      description
      updatedAt
    }
  }
`;

export const ADD_BUSINESS_STRUCTURE_NODE = gql`
  mutation AddBusinessStructureNode($input: AddBusinessStructureNodeInput!) {
    addBusinessStructureNode(input: $input) {
      id
      businessStructureId
      kind
      playbookId
      label
      notes
      stage
      positionX
      positionY
      playbook {
        id
        name
        objective
      }
    }
  }
`;

export const UPDATE_BUSINESS_STRUCTURE_NODE = gql`
  mutation UpdateBusinessStructureNode($input: UpdateBusinessStructureNodeInput!) {
    updateBusinessStructureNode(input: $input) {
      id
      businessStructureId
      kind
      playbookId
      label
      notes
      stage
      positionX
      positionY
      playbook {
        id
        name
        objective
      }
    }
  }
`;

export const REMOVE_BUSINESS_STRUCTURE_NODE = gql`
  mutation RemoveBusinessStructureNode($input: RemoveBusinessStructureNodeInput!) {
    removeBusinessStructureNode(input: $input)
  }
`;

export const ADD_BUSINESS_STRUCTURE_LINK = gql`
  mutation AddBusinessStructureLink($input: AddBusinessStructureLinkInput!) {
    addBusinessStructureLink(input: $input) {
      id
      businessStructureId
      fromNodeId
      toNodeId
      outcomeKey
      label
      isDefault
      sortOrder
    }
  }
`;

export const UPDATE_BUSINESS_STRUCTURE_LINK = gql`
  mutation UpdateBusinessStructureLink($input: UpdateBusinessStructureLinkInput!) {
    updateBusinessStructureLink(input: $input) {
      id
      businessStructureId
      fromNodeId
      toNodeId
      outcomeKey
      label
      isDefault
      sortOrder
    }
  }
`;

export const REMOVE_BUSINESS_STRUCTURE_LINK = gql`
  mutation RemoveBusinessStructureLink($input: RemoveBusinessStructureLinkInput!) {
    removeBusinessStructureLink(input: $input)
  }
`;
